import { http } from '@/services'

export const practiceService = {
    dashboard: () => {
        return http.get('practice/dashboard')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getPractice: () => {
        return http.get('practice')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            })
    },
    setPractice: (practice) => {
        return http.put('practice', practice)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            })
    },
    getBA: (id) => {
        let url = 'practice/ba';
        if (id) url += '/' + id;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setBA: (ba) => {
        return http.post('practice/ba/' + ba.id, ba)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    deleteBA: (ba) => {
        return http.delete('practice/ba/' + ba.id)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getLogbook: () => {
        return http.get('practice/logbook')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            })
    },
    setLogbook: (log) => {
        return http.post('practice/logbook', { log })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            })
    },
    getActivity: (id) => {
        let url = 'practice/activity';
        if (id) url += '/' + id;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setActivity: (activity) => {
        return http.post('practice/activity/' + activity.id, activity)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    deleteActivity: (activity) => {
        return http.delete('practice/activity/' + activity.id)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getActivityMap: () => {
        return http.get('practice/activity/map')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getFlags: () => {
        return http.get('practice/flags', { hmNoRedirect: true })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setFlags: (flags) => {
        return http.put('practice/flags', flags)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    }
};